import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import formatBRL from "../../../shared/utils/formatBRL";

const shortBRL = (v) =>
  v >= 1000 ? `R$ ${(v / 1000).toLocaleString("pt-BR")} mil` : `R$ ${v}`;

/**
 * Card "Receita por dia" — `data` vem de revenueByPeriod(). O seletor
 * troca entre diário e mensal (`granularity` / `onGranularityChange`).
 */
const RevenueChart = ({ data = [], granularity, onGranularityChange }) => (
  <section className="sales-card sales-revenue">
    <header className="sales-card__header">
      <h2 className="sales-card__title">
        {granularity === "monthly" ? "Receita por mês" : "Receita por dia"}
      </h2>
      <select
        className="sales-select sales-select--compact"
        aria-label="Agrupamento do gráfico"
        value={granularity}
        onChange={(e) => onGranularityChange(e.target.value)}
      >
        <option value="daily">Diário</option>
        <option value="monthly">Mensal</option>
      </select>
    </header>

    <div className="sales-revenue__chart">
      {data.length === 0 ? (
        <p className="sales-empty">Sem vendas nesse período.</p>
      ) : (
        <ResponsiveContainer>
          <LineChart
            data={data}
            margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
          >
            <CartesianGrid vertical={false} stroke="#efefef" />
            <XAxis
              dataKey="label"
              tick={{ fontSize: 11, fill: "#777" }}
              tickLine={false}
              axisLine={false}
              interval="preserveStartEnd"
              minTickGap={24}
            />
            <YAxis
              tick={{ fontSize: 11, fill: "#777" }}
              tickLine={false}
              axisLine={false}
              width={72}
              tickFormatter={shortBRL}
            />
            <Tooltip formatter={(value) => [formatBRL(value), "Receita"]} />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#111"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  </section>
);

export default RevenueChart;
